import {
  Div,
  FontIcon,
  MediumOutlineButton,
  PopoverMenu,
  Text2,
  Text3,
  AddIcon,
  TinyOutlineButton
} from "components/Base";
import contactMembersCss from "./styles.scss";
// import CollapsablePanel from "ui-kit/CollapsiblePanel";
import CollapsablePanel from "Portal/NewPortal/Shared/CollapsablePanel";
import React, { useState, useEffect } from "react";
import CheckBox from "material-ui/Checkbox";
import ModalWrapper from "components/Global/Modal/Wrappers/Black";
import AddContactMemberModal from "../AddContactMemberModal/View";
import { showModal, hideModal } from "redux/modules/modal/actions";
import * as R from "ramda";
import { connect } from "react-redux";
import { noop } from "utils/General";
import { addS } from "utils/General";
import ConfirmationModal from "./ConfirmationModal";
import { getters as PortalHomeGetters } from "Portal/NewPortal/PortalHome/model";
import { actions, getters } from "../../../model";
import Loading from "ui-kit/Loading";

const decorate = R.compose(
  connect(
    state => ({
      styles: PortalHomeGetters.styles(state),
      contactMembers: getters.contactMembers(state),
      loadingContacts: getters.loadingContacts(state),
      enableAdditionalContacts: getters.enableAdditionalContacts(state)
    }),
    {
      getContactMembers: actions.getContactMembers,
      deleteContactMembers: actions.deleteContactMembers,
      showModal: showModal,
      hideModal: hideModal
    }
  )
);

const AdditionalContacts = ({
  styles,
  contactMembers,
  showModal = noop,
  hideModal = noop,
  deleteContactMembers,
  getContactMembers,
  loadingContacts,
  enableAdditionalContacts,
  // canCreateContacts = true,
  canUpdateContacts = true
  // canDeleteContacts = true
}) => {
  if (!enableAdditionalContacts) {
    return null;
  }
  useEffect(() => {
    getContactMembers();
  }, []);

  const [selectedMembers, setSelectedMembers] = useState([]);
  const toggleMember = id => {
    let newMembers;
    if (!selectedMembers.includes(id)) {
      newMembers = [...selectedMembers, id];
    } else {
      newMembers = selectedMembers;
      newMembers.splice(selectedMembers.indexOf(id), 1);
    }
    setSelectedMembers([...newMembers]);
  };
  const selectAll = () => {
    setSelectedMembers([
      ...contactMembers.map(contactMember => contactMember.id)
    ]);
  };
  const selectNone = () => setSelectedMembers([]);
  /**
   * Uncomment to enable bulk delete
   */
  // const bulkDelete = () =>
  //   showModal({
  //     content: (
  //       <ConfirmationModal
  //         onConfirm={() =>
  //           deleteContactMembers(selectedMembers)
  //         }
  //         confirmLabel={"Delete"}
  //         hideModal={hideModal}
  //         heading={`Delete ${selectedMembers.length} Additional Contact${addS(
  //           selectedMembers.length
  //         )}`}
  //         firstLine={
  //           <>
  //             Are you sure you want to <b>permanently delete </b>
  //             {contactMembers
  //               .filter(contact => selectedMembers.includes(contact.id))
  //               .map(contact => `${contact.firstName} ${contact.lastName}`)
  //               .join(", ")}
  //             ?
  //           </>
  //         }
  //         secondLine={
  //           <Text3 pt={3}>
  //             This will remove the contact from our system. They will not be
  //             able to access any speaker portals or be copied in communication{" "}
  //             <b>unless they are re-added.</b>
  //           </Text3>
  //         }
  //       />
  //     ),
  //     wrapper: ModalWrapper
  //   });
  const bulkRemove = () =>
    showModal({
      content: (
        <ConfirmationModal
          orangeButton={false}
          confirmLabel={"Remove"}
          onConfirm={() => deleteContactMembers(selectedMembers)}
          hideModal={hideModal}
          heading={`Remove ${selectedMembers.length} Additional Contact${addS(
            selectedMembers.length
          )}`}
          firstLine={
            <>
              Are you sure you want to remove {contactMembers.length}{" "}
              {contactMembers.length === 1 ? "person" : "people"}?
            </>
          }
          secondLine={
            <>
              <Text3 bold pt={3} mb={3}>
                This will remove the contact{addS(selectedMembers)} from
                accessing this speaker’s portal.
              </Text3>
              <Text3>
                Contact{addS(selectedMembers)} will not be cc’d on any future
                communications to this speaker.
              </Text3>
            </>
          }
        />
      ),
      wrapper: ModalWrapper
    });

  const addContactButton = canUpdateContacts ? (
    <div
      style={{
        justifyContent: "flex-start",
        alignItems: "center",
        gap: "4px",
        display: "inline-flex",
        marginRight: "4px",
        cursor: "pointer"
      }}
      onClick={e => {
        e.stopPropagation();
        showModal({
          content: <AddContactMemberModal onDone={() => getContactMembers()} />,
          wrapper: ModalWrapper
        });
      }}
    >
      <div style={{ width: 14, height: 18, position: "relative" }}>
        <AddIcon
          mr={1}
          color={styles.accent_color ? styles.accent_color : "#4263EB"}
          size={14}
        />
      </div>
      <div
        style={{
          color: styles.accent_color ? styles.accent_color : "#4263EB",
          fontSize: "14px",
          fontWeight: "600",
          wordWrap: "break-word"
        }}
      >
        Add Additional Contact
      </div>
    </div>
  ) : null;

  return (
    <Div display="column">
      <CollapsablePanel
        title="Additional Contacts"
        extraButton={addContactButton}
      >
        <Div
          display="column.center.baseline"
          p={5}
          style={
            contactMembers.length
              ? {
                  gap: 2
                }
              : {
                  gap: 2,
                  paddingTop: "0px"
                }
          }
          width={1}
        >
          {contactMembers.length && canUpdateContacts ? (
            <Div
              display="flex.justify-content.center"
              className={contactMembersCss.selectFilter}
            >
              <Text2 bold mr={2}>
                Select
              </Text2>
              <Div display="flex.justify-content.center">
                <Text2
                  onClick={selectAll}
                  className={contactMembersCss.selectFilterOption}
                  color={styles.accent_color ? styles.accent_color : "#4263EB"}
                >
                  All
                </Text2>
                <Text2 mx={1}>/</Text2>
                <Text2
                  onClick={selectNone}
                  className={contactMembersCss.selectFilterOption}
                  color={styles.accent_color ? styles.accent_color : "#4263EB"}
                >
                  None
                </Text2>
              </Div>
            </Div>
          ) : null}
          {contactMembers.length ? (
            <Div display="flex.justify-content.center" mt={2} mb={4}>
              {canUpdateContacts ? (
                <MediumOutlineButton
                  disabled={!selectedMembers.length}
                  onClick={bulkRemove}
                  mr={1}
                >
                  Remove
                </MediumOutlineButton>
              ) : null}
              {/**
           Uncomment to enable bulk delete button
           */}
              {/* <MediumOutlineButton
            disabled={!selectedMembers.length}
            onClick={bulkDelete}
          >
            Delete
          </MediumOutlineButton> */}
            </Div>
          ) : null}
          <Div width={1} className={contactMembersCss.membersTable}>
            <Div className={contactMembersCss.membersTableHeader}>
              <Div className={contactMembersCss.membersTableHeaderCell}>
                Name
              </Div>
              <Div className={contactMembersCss.membersTableHeaderCell}>
                Email
              </Div>
              <Div className={contactMembersCss.membersTableHeaderCell}>
                Role
              </Div>
              {canUpdateContacts && (
                <Div className={contactMembersCss.membersTableHeaderCell}>
                  Actions
                </Div>
              )}
            </Div>
            <Div>
              {loadingContacts ? (
                <Loading />
              ) : contactMembers.length ? (
                contactMembers.map(contactMember => (
                  <Div className={contactMembersCss.membersTableRow}>
                    <Div className={contactMembersCss.membersTableCell}>
                      <Div
                        display="flex.flex-start.center"
                        className={contactMembersCss.membersTableLeftContainer}
                      >
                        {canUpdateContacts ? (
                          <CheckBox
                            checked={selectedMembers.includes(contactMember.id)}
                            onClick={() => toggleMember(contactMember.id)}
                            iconStyle={{ width: "16px", height: "16px" }}
                            style={{ width: "auto" }}
                          />
                        ) : null}
                        <i className="material-icons">person_outline</i>
                        <Text2 bold ml={2}>
                          {`${contactMember.firstName} ${contactMember.lastName}`}
                        </Text2>
                      </Div>
                    </Div>
                    <Div className={contactMembersCss.membersTableCell}>
                      <Div display="flex.flex-start.center">
                        <i className="material-icons">mail_outline</i>
                        <Text2 ml={2}>{contactMember.email}</Text2>
                      </Div>
                    </Div>
                    <Div className={contactMembersCss.membersTableCell}>
                      <Text2>
                        {contactMember.role && contactMember.role.length
                          ? contactMember.role
                          : "-"}
                      </Text2>
                    </Div>
                    {canUpdateContacts ? (
                      <Div className={contactMembersCss.membersTableCell}>
                        <Div
                          display="flex.flex-end.center"
                          className={
                            contactMembersCss.membersTableRightContainer
                          }
                        >
                          <PopoverMenu
                            Label={({ onClick }) => (
                              <TinyOutlineButton onClick={onClick} py={1}>
                                <FontIcon fs={3}>more_horiz</FontIcon>
                              </TinyOutlineButton>
                            )}
                            menuItems={[
                              // [
                              //   "Edit",
                              //   () =>
                              //     showModal({
                              //       content: (
                              //         <AddContactMemberModal
                              //           onDone={() => getContactMembers()}
                              //           userDataToEdit={contactMember}
                              //         />
                              //       ),
                              //       wrapper: ModalWrapper
                              //     })
                              // ],
                              [
                                "Remove",
                                () =>
                                  showModal({
                                    content: (
                                      <ConfirmationModal
                                        onConfirm={() =>
                                          deleteContactMembers([
                                            contactMember.id
                                          ])
                                        }
                                        orangeButton={true}
                                        hideModal={hideModal}
                                        confirmLabel={"Remove"}
                                        heading={"Remove Additional Contact"}
                                        firstLine={
                                          <>
                                            Are you sure you want to remove this
                                            person?
                                          </>
                                        }
                                        secondLine={
                                          <>
                                            <Text3 bold pt={3} mb={3}>
                                              This will remove the contact from
                                              accessing this speaker’s portal.
                                            </Text3>
                                            <Text3>
                                              Contact will not be cc’d on any
                                              future communications to this
                                              speaker.
                                            </Text3>
                                          </>
                                        }
                                      />
                                    ),
                                    wrapper: ModalWrapper
                                  })
                              ]
                              /**
                               * Uncomment these lines to enable individual delete
                               */
                              /*[
                              "Delete",
                              () =>
                                showModal({
                                  content: (
                                    <ConfirmationModal
                                      onConfirm={() =>
                                        deleteContactMembers([contactMember.id])
                                      }
                                      hideModal={hideModal}
                                      confirmLabel={"Delete"}
                                      heading={"Delete Additional Contact"}
                                      firstLine={
                                        <>
                                          Are you sure you want to{" "}
                                          <b>permanently delete</b> this
                                          contact?
                                        </>
                                      }
                                      secondLine={
                                        <Text3 pt={3}>
                                          This will remove the contact from our
                                          system. They will not be able to
                                          access any speaker portals or be
                                          copied in communication{" "}
                                          <b>unless they are re-added.</b>
                                        </Text3>
                                      }
                                    />
                                  ),
                                  wrapper: ModalWrapper
                                })
                            ]*/
                            ].filter(o => o)}
                          />
                        </Div>
                      </Div>
                    ) : null}
                  </Div>
                ))
              ) : (
                <Text2 mt={5}>No additional contacts have been added</Text2>
              )}
            </Div>
          </Div>
        </Div>
      </CollapsablePanel>
    </Div>
  );
};

export default decorate(AdditionalContacts);
